import { render, staticRenderFns } from "./ProductSpecs.vue?vue&type=template&id=1f76de00&scoped=true"
import script from "./ProductSpecs.vue?vue&type=script&lang=js"
export * from "./ProductSpecs.vue?vue&type=script&lang=js"
import style0 from "./ProductSpecs.vue?vue&type=style&index=0&id=1f76de00&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76de00",
  null
  
)

export default component.exports